import { baseConfigSchema, createConfigContext } from '@cez-dje/providers';
import { z } from 'zod';

export const appConfigSchema = baseConfigSchema.extend({
  API_BASE_URL: z.string(),
  CONSUMER_SECRET: z.string(),
  RECAPTCHA_SITE_KEY: z.string(),
});

export type AppConfig = z.infer<typeof appConfigSchema>;

export const { ConfigProvider, useConfig, getConfig } = createConfigContext<AppConfig>();
